






// TODO: Add logic to show login / dashboard (probably based on routes)
import TresPortalBaseAxiosHelper from "@/util/axios";

import axios from "axios";
import Vue from "vue";
import Store from "@/store";
// // import Account from "@/views/Account.vue";
// import Dashboard from "@/templates/Dashboard.vue";

export default Vue.extend({
  name: "MijnSpits",
  mounted() {
    const refreshAccessToken = async () => {
      await Store.dispatch("auth/refresh");
      return Store.getters["auth/getAuth"].accessToken || "";
    };

    const axiosHelper = new TresPortalBaseAxiosHelper(
      axios,
      refreshAccessToken
    );
    axiosHelper.setup();
  }
});
